// lib/signupFlag.ts
/**
 * Public self-serve signup is closed by default — B2B accounts are
 * provisioned by staff (see CHANGELOG "B2B-only account routing"). The
 * /signup page, the signup AuthForm, and the referral flow are all still in
 * place; nothing was deleted. Set NEXT_PUBLIC_SIGNUP_ENABLED=true (in
 * .env.local / Vercel) to re-open them without touching any code.
 *
 * Safe to import from client components, server components, and middleware
 * (no "server-only" — this only reads a NEXT_PUBLIC_ var, which Next.js
 * inlines into both the client and server bundles at build time).
 */
export function isPublicSignupEnabled(): boolean {
  return process.env.NEXT_PUBLIC_SIGNUP_ENABLED === "true";
}
